(function () {
  const BLOCKED_HANDLES = [];

  // Handle nikalo: URL se, ya page ke data-product-handle se
  const urlMatch = location.pathname.match(/\/products\/([^\/?#]+)/);
  const handle = (urlMatch && urlMatch[1])
    || (document.querySelector('[data-product-handle]') || {}).dataset?.productHandle
    || (document.querySelector('product-media') || {}).getAttribute?.('product-handle');

  if (!BLOCKED_HANDLES.includes(handle)) {
    console.log('Ye product blocked list me nahi hai:', handle);
    return;
  }

  let style = document.getElementById('atc-block-style');
  if (!style) {
    style = document.createElement('style');
    style.id = 'atc-block-style';
    document.head.appendChild(style);
  }
  style.textContent = `
    #AddToCart,
    [data-product-add-to-cart-button],
    .product-form__add-button,
    #AddToCart * {
      opacity: .5 !important;
      cursor: not-allowed !important;
      pointer-events: auto !important;
    }`;

  function disableAll() {
    document.querySelectorAll('#AddToCart, [data-product-add-to-cart-button], .product-form__add-button')
      .forEach(function (b) { b.setAttribute('aria-disabled', 'true'); });
  }

  function blockEvent(e) {
    const t = e.target;
    if (!t.closest) return;
    if (t.closest('#AddToCart, [data-product-add-to-cart-button], .product-form__add-button, form[action="/cart/add"]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }
  document.addEventListener('click', blockEvent, true);
  document.addEventListener('submit', blockEvent, true);

  new MutationObserver(disableAll).observe(document.body, { childList: true, subtree: true });
  disableAll();
  console.log('ATC blocked for handle:', handle);
})();